import React from "react";
import { ArrowLeft, MapPin, Store } from "lucide-react";
import { Link } from "react-router-dom";
import VillageImage from "../assets/images/thatch-roof-house_compressed.webp";
import CafeImage from "../assets/images/rustic-chandelier-made-bulbs-ropes-dining-table-vintage-kitchen_compressed.webp";
import ResortImage from "../assets/images/dining-terrace-open-restaurant-with-sofas-chairs-tables_compressed.webp";
import storeIcon from "../assets/images/store-location-icon-v3.png"
import plant from "../assets/images/plant.svg"

const BusinessRegistrationBanner: React.FC = () => (
  <section className="site-container py-6 tablet:py-8" aria-labelledby="business-registration-title">
    <div className="relative isolate overflow-hidden rounded-2xl  border-[#dcebdd] bg-[#C1E1C1]/15 px-4 py-5 tablet:px-8 tablet:py-7 desktop:px-12 desktop:py-8">
      {/* <MapPin
        aria-hidden="true"
        className="pointer-events-none absolute -bottom-8 -left-4 h-16 w-16 text-[#97d2b5]/35 tablet:-bottom-1 tablet:left-6 tablet:h-24 tablet:w-24"
        strokeWidth={1.1}
      /> */}
      {/* <Store
        aria-hidden="true"
        className="pointer-events-none absolute bottom-8 left-4 hidden h-12 w-12 text-[#97d2b5]/40 desktop:block"
        strokeWidth={1.15}
      /> */}
{/* <img src={storeIcon} alt="" className="pointer-events-none absolute bottom-8 left-4 h-16 w-16 " /> */}
      <img src={storeIcon} alt="" className="pointer-events-none absolute left-20 top-16 h-16 w-16 " />
      <img src={plant} alt="" className="pointer-events-none absolute bottom-8 left-8 h-16 w-16 " />

      <div dir="ltr" className="relative z-10 flex flex-col gap-6 tablet:flex-row tablet:items-center tablet:justify-center tablet:gap-8 desktop:gap-16">
        <div dir="rtl" className="order-2 min-w-0 text-center tablet:order-none tablet:max-w-[42%] px-2">
          <h2 id="business-registration-title" className="text-xl leading-9 text-[#155c3b] font-myYekanFaNumExtraBold tablet:text-2xl tablet:leading-10 desktop:text-3xl desktop:leading-[3rem]">
            کسب‌وکار شما، بخشی از تجربه سفر  
          </h2>
          <p className="mx-auto mt-2 max-w-md text-sm leading-7 p-2 text-gray-700 font-myYekanRegular tablet:text-base">

کسب‌وکارتان را در لوتکا معرفی کنید تا مقصد بعدی مسافران، شما 
باشید.          </p>
          <Link
            to="/place-contributions/new"
            className="mt-4 inline-flex h-11 items-center justify-center gap-2 rounded-xl bg-[#038545] px-5 text-sm text-white transition-colors hover:bg-[#068646] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#038545] focus-visible:ring-offset-2 font-myYekanFaNumDemiBold tablet:mt-5"
          >
            ثبت کسب‌وکار شما
          </Link>
        </div>

        <div dir="rtl" className="order-1 relative mx-auto h-52 w-full max-w-md tablet:order-none tablet:mx-0 tablet:h-56 tablet:max-w-[40%] desktop:h-64 desktop:max-w-[520px]">
          <img
            src={VillageImage}
            alt="بومگردی"
            className="absolute left-1/2 top-0 h-full w-[80%] -translate-x-1/2 rounded-2xl object-cover shadow-sm"
          />
          <img
            src={CafeImage}
            alt="کافه محلی"
            className="absolute bottom-[-10px] left-0 z-10 h-[64%] w-[40%] rounded-2xl border border-white object-cover shadow-md tablet:bottom-[-14px] tablet:left-[-18%] desktop:left-[-16%]"
          />
          <img
            src={ResortImage}
            alt="رستوران محلی"
            className="absolute bottom-[-10px] right-0 z-10 h-[64%] w-[40%] rounded-2xl border border-white object-cover shadow-md tablet:bottom-[-14px] tablet:right-[-18%] desktop:right-[-16%]"
          />
        </div>
      </div>
    </div>
  </section>
);

export default BusinessRegistrationBanner;
